<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.service_chan{
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  li{
    width: 190px;
    height: 188px;
    margin-right: 170px;
    background: url("../../assets/img/Virus/Virus/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p{
      font-size: 16px;
      color:#4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color:#959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/Virus/Virus/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }
    .liaojie{
      color: #fff;
    }
  }
  li:last-child{
    margin-right: 0;
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.compose-type1{
  margin-top: 100px;
  padding-bottom: 50px;
  background: url("../../assets/img/Virus/Lentivirus/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.required{
  background: none!important;
  margin-left: 0!important;
}
.desc{
  font-size: 16px;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/Virus/Lentivirus/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons">
      <img src="@/assets/img/二级标题Banner/慢病毒包装banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container">
        <p class="desc" style="margin-bottom: 10px;color:#014492;font-weight:bold;">慢病毒包装</p>
        <p class="desc">慢病毒（Lentivirus）载体是以HIV-1为基础发展起来的基因治疗载体，可以将外源基因或外源干扰序列有效地整合到宿主染色体上，从而达到持久性表达目的序列的效果。区别一般的逆转录病毒载体，它对分裂细胞和非分裂细胞均具有感染能力，常用于感染难转染的细胞，如原代细胞、神经元细胞、干细胞、不分化细胞、肝细胞、内皮细胞、肿瘤细胞等，转染效率近100%，是介导外源基因表达的强大工具，可在体内和体外实现过表达、基因沉默、基因编辑等多种应用，让基因功能研究变得更加便利。</p>
      </div>
      <div class="container">
        <div class="c-title">实验流程<small>Experimental process</small></div>
        <div style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;" class="con"><img src="@/assets/img/Virus/Lentivirus/lc.png" class="img-fluid"></div>
        <div style="margin-top: 20px; width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;" class="cons"><img src="@/assets/img/Virus/Lentivirus/lc_2.png" class="img-fluid" style="width: 200px;"></div>
      </div>
      <div class="container">
        <div class="c-title">服务价格<small>Service price</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="滴度">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="规格">
              <template slot-scope="scope">
                <div v-html="scope.row.method3"></div>
              </template>
            </el-table-column>
            <el-table-column
              prop="method4"
              label="擎科促销价/元">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="周期/工作日">
            </el-table-column>
            <el-table-column
              prop="method6"
              label="备注">
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 30px;">备注：所以产品均免费提供1 mL对照慢病毒、完整实验及检测报告和使用说明书。</div>
      </div>
      <div class="compose-type1">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/Virus/Lentivirus/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.<span style="font-weight:bold;">表达时间长：</span>慢病毒通过将外源基因整合到宿主细胞基因组上，可实现目的基因长时间稳定的表达，不随着细胞分裂传代而丢失。</p>
                <p class="mb20">2.<span style="font-weight:bold;">安全性高：</span>未发现致病性，已被用于CAR-T治疗人类疾病。</p>
                <p class="mb20">3.<span style="font-weight:bold;">免疫原性低：</span>直接注射活体组织不易造成免疫反应，适用于动物实验。</p>
                <p>4.<span style="font-weight:bold;">多样化选择：</span>擎科生物可提供多种启动子、开关元件、荧光报告基因和抗性筛选基因的慢病毒，可以满足您的各种实验需求。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <ul class="effect-lists con">
          <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`">
            <p style="margin-top: 10px;">{{item.name}}</p>
          </li>
        </ul>
        <div class="cons">
          <ul class="effect-lists" style="margin-top: 20px;display: flex!important;justify-content: center!important;">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>

      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData:[
        {
          method1:'过表达慢病毒定制',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管<br />赠送1mL对照',
          method4:'3500',
          method5:'25',
          method6:'插入片段＞3 kb需另外评估',
        },
        {
          method1:'miRNA过表达/ 干扰慢病毒定制',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管<br />赠送1mL对照',
          method4:'4800',
          method5:'25',
          method6:'',
        },
        {
          method1:'干扰慢病毒定制',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管<br />赠送1mL对照',
          method4:'2250',
          method5:'25',
          method6:'不保证干扰效果',
        },
        {
          method1:'干扰慢病毒定制 三筛一',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管<br />赠送1mL对照',
          method4:'6500',
          method5:'25',
          method6:'擎科验证干扰效率并发货一个慢病毒，保证在模式细胞中干扰效率≥70%\n',
        },
        {
          method1:'干扰慢病毒定制 干扰慢病毒定制 三保一\n',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管<br />赠送1mL对照',
          method4:'6500',
          method5:'25',
          method6:'擎科发货三个慢病毒，保证在转染效率＞90%的情况下，至少一个慢病毒干扰效率≥70%\n',
        },
        {
          method1:'过表达对照慢病毒',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管',
          method4:'1800',
          method5:'5',
          method6:'',
        },
        {
          method1:'干扰对照慢病毒',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管',
          method4:'1500',
          method5:'5',
          method6:'',
        },
        {
          method1:'包装质粒pMD2.G、psPAX2',
          method2:'/',
          method3:'5 μg',
          method4:'2400',
          method5:'5',
          method6:'',
        },
        {
          method1:'CRISPR allin one 敲除慢病毒单靶点\n',
          method2:'≥1E+8TU/mL',
          method3:'5*200 μL/管',
          method4:'2800',
          method5:'22',
          method6:'不保证切割活性',
        },
        {
          method1:'CRIPRallinone 敲除慢病毒三靶点',
          method2:'1E+8TU',
          method3:'5x200 μL/管',
          method4:'8500',
          method5:'22',
          method6:'若三靶点均无切割活性，承诺再补发三个慢病毒',
        },
      ],
      currentType: -1,
      currentService: -1,
      types: [
        {name: '腺病毒包装', img: '2', ref: '/Virus/Adenovirus_packaging'},
        {name: '腺相关病毒包装', img: '3', ref: '/Virus/Adeno_associated_virus'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Virus/Lentivirus_packaging.vue